import Graphene from "@snapchat/graphene";
import { getDeviceName } from "@snapchat/web-graphene-reporting";
import { Namespace } from "@snapchat/web-experiments";
import { POLICY_DIRECTIVES } from "../constants/csp";
import preconnects from "../preconnect-origins";
export const getBaseShellProps = () => ({
    onGrafanaMetricsReady: () => {
        Graphene.increment({ metricsName: `Lens.${getDeviceName()}.page_view` });
    },
    preconnects,
    policyDirectives: POLICY_DIRECTIVES,
    webConfigNamespaces: [Namespace.WEB_STORY_CORE, Namespace.WEB_STORY_UI, Namespace.SHARED_WEB_UI],
});
